import React, { Component } from "react";
import http from '../modules/api';
import * as StringUtil from '../modules/utils/StringUtil';
import * as ArrayUtil from '../modules/utils/ArrayUtil';
import SaveDialogV2 from '../modules/dialogs/SaveDialogV2';
import round_loading_bar_purple from '../../resources/img/round_loading_bar_purple.gif';

var object_domain = document.domain.indexOf("robomd.io") > -1 ? "https://robomd.io" : "https://"+document.domain;
var object_port = window.location.port;
if (document.domain.indexOf("127.0.0.1") >= 0 && object_port == "3000") {
    object_domain = "https://127.0.0.1:8092"
} else if (object_port != '') {
    object_domain = object_domain + ":" + object_port
}
var rp_script_url = object_domain+"/js/robomd_product_rolling_for_curation.js"

/**
 * 쇼핑 큐레이션 설문 팝업
 * - 모든 동작 state 기반
 * - Tailwind 클래스 그대로 사용 가능
 * - 외부 CSS에 .survey-container, .option-btn, .fade-in 등만 추가해 주면 됩니다.
 */
const SURVEY_DATA = [
  {
    id: 1,
    question: "누구를 위한 선물을\n준비하고 계신가요?",
    description: "가장 적절한 대상을 선택해주세요.",
    options: [
      { text: "우리 아이 (유아/아동)", value: "child" },
      { text: "부모님 혹은 성인 가족", value: "adult" },
      { text: "출산/임신 축하 선물", value: "baby" },
    ],
  },
  {
    id: 2,
    question: "평소 선호하시는\n디자인 스타일은?",
    description: "무냐무냐의 다양한 라인업 중 추천해드려요.",
    options: [
      { text: "고급스러운 패턴의 클래식 라인", value: "classic" },
      { text: "아이들이 좋아하는 캐릭터 라인", value: "character" },
      { text: "심플하고 깨끗한 베이직 라인", value: "basic" },
    ],
  },
  {
    id: 3,
    question: "제품 구매 시\n가장 중요하게 보는 것은?",
    description: "우선순위 한 가지만 골라주세요.",
    options: [
      { text: "피부에 닿는 소재와 촉감", value: "material" },
      { text: "오래 입을 수 있는 내구성", value: "durability" },
      { text: "세련되고 예쁜 디자인", value: "design" },
    ],
  },
];

class UserCurationQuestion_v2 extends Component {
  static defaultProps = {
    // 팝업 닫기 콜백 (선택)
    onClose: null,
    // 설문 완료 콜백 (선택) - userAnswers를 인자로 전달
    onComplete: null,
  };

  constructor(props) {
    super(props);

    this.state = {
        curation: {
            questions: []
        },

        answers : [],

        tailwindLoaded: false,
        currentStep: 0, // 0부터 시작 (index)
        userAnswers: {}, // {0: 'child', 1: 'classic', ...}
        showResult: false,
        resultText: "무냐무냐 베스트 셀러",

        show_save_loading_dialog: false,
        save_dialog_content : "답변을 제출하는 중입니다.<br/>잠시만 기다려주세요.",

        isMobile: false,

        file_domain: "https://s3.ap-northeast-2.amazonaws.com/",

        member_id: StringUtil.getUrlParams("member_id") != null ? StringUtil.getUrlParams("member_id") : "",
        cookie_robotmd_user: StringUtil.getUrlParams("cookie_robotmd_user") != null ? StringUtil.getUrlParams("cookie_robotmd_user") : "",
        service_uid: StringUtil.getUrlParams("service_uid") != null ? StringUtil.getUrlParams("service_uid") : "",
    };
  }

  componentDidMount() {
    // Tailwind CDN 스크립트 동적 로드
    const script = document.createElement("script");
    script.src = "https://cdn.tailwindcss.com";
    script.onload = () => {
      console.log("Tailwind Loaded ✔");
      this.setState({ tailwindLoaded: true });
    };
    document.body.appendChild(script);

    if (navigator.userAgentData) {
        const isMobile = navigator.userAgentData.mobile;
        
        if (isMobile) {
            this.setState({ isMobile: true });
        }
    }

    const {curation_seq} = this.props.match.params;
    this.setState({ curation_seq: curation_seq }, () => {
        this.loadCurationDetail();
    });

    // 컴포넌트 마운트 시 채널톡 숨기기
    if (window.ChannelIO) {
       window.ChannelIO('hideChannelButton'); // 채널톡 버튼 숨김 (페이지 새로고침 하지 않은 경우, SPA)
       window.ChannelIO('onBoot', function() { // 채널톡 로딩 완료 체크 후 숨김 처리 (페이지 새로고침 한 경우)
            window.ChannelIO('hideChannelButton'); // 채널톡 버튼 숨김
       });
    }
  }

  componentWillUnmount() {
    // 컴포넌트 제거 시 Tailwind 스크립트 삭제 (선택 사항)
    const scripts = document.querySelectorAll('script[src="https://cdn.tailwindcss.com"]');
    scripts.forEach((s) => s.remove());

    if (window.ChannelIO) {
      window.ChannelIO('showChannelButton');
    }
  }

  async loadCurationDetail() {
    await http.get("/rest/common/curation/detail/"+this.state.curation_seq)
    .then(res => {
        if (res.data.code == 200) {
            this.setState({
                curation: res.data["curation"],
            })
        } else {
            alert("큐레이션 질문이 존재하지 않습니다.")
            window.location.href = "/common/curation/list/"+(StringUtil.getUrlParams("service_uid") != null ? StringUtil.getUrlParams("service_uid")  : "")
                                    +"?cookie_robotmd_user="+(StringUtil.getUrlParams("cookie_robotmd_user") != null ? StringUtil.getUrlParams("cookie_robotmd_user")  : "")
                                    +"&member_id="+(StringUtil.getUrlParams("member_id") != null ? StringUtil.getUrlParams("member_id")  : "")
                                    +"&guest_id="+(StringUtil.getUrlParams("guest_id") != null ? StringUtil.getUrlParams("guest_id")  : "")
        }
    })
    .catch(error => {
        console.log("큐레이션 질문 조회 오류", error)
        alert("큐레이션 질문이 존재하지 않습니다.")
        window.location.href = "/common/curation/list/"+(StringUtil.getUrlParams("service_uid") != null ? StringUtil.getUrlParams("service_uid")  : "")
                                +"?cookie_robotmd_user="+(StringUtil.getUrlParams("cookie_robotmd_user") != null ? StringUtil.getUrlParams("cookie_robotmd_user")  : "")
                                +"&member_id="+(StringUtil.getUrlParams("member_id") != null ? StringUtil.getUrlParams("member_id")  : "")
                                +"&guest_id="+(StringUtil.getUrlParams("guest_id") != null ? StringUtil.getUrlParams("guest_id")  : "")
    });
}   

    onClickSubmit(e) {
        /* 큐레이션 사용자 질문 validate 체크 */
        let questions = JSON.parse(JSON.stringify(this.state.curation["questions"])); // 질문 리스트
        console.log("questions", questions);
        let answers = JSON.parse(JSON.stringify(this.state.answers)); // 답변 리스트
        console.log("answers", answers);
        let filter_questions = ArrayUtil.diffrentTwoArrayObject(questions, answers, "question_seq", "question_seq") // 답변이 누락된 질문 리스트 추출   
        console.log("filter_questions.length", filter_questions.length);
        if (filter_questions.length > 0) { // 답변이 누락된 질문 리스트가 있으면
            // let scrollTop = $("#"+filter_questions[0]["question_seq"]).offset().top - $("#curation_header").height(); // 답변이 누락된 질문의 스크롤 높이 추출
            // $(document).scrollTop(scrollTop); // 답변이 누락된 질문으로 스크롤 이동
            this.setState({
                basic_dialog_show_state : true, // 다이얼로그 띄우기
                basic_dialog_content : "답변이 누락된 질문이 있습니다."
            })
            return false;
        }

        this.postCurationAnswer();
    }

    /*
    http://127.0.0.1:3000/common/curation/question_v2/29?member_id=&cookie_robotmd_user=RM2.4.9809388866.1758203227345&service_uid=b85a889c-bedf-11f0-9c41-0a9ea40d
    */
    // 큐레이션 답변 제출
    async postCurationAnswer() {
        let user_answers = [];
        for (let idx in this.state.answers) {
            user_answers.push(this.state.answers[idx]["answer_seq"]);
        }

        const config = {
            headers: {
                'content-type': 'application/json;'
            },
        }
        let body = {
            curation_seq: this.state.curation["curation_seq"],
            cookie_robotmd_user: this.state.cookie_robotmd_user,
            member_id: this.state.member_id,
            guest_id: this.state.guest_id,
            user_answers: user_answers
        }    

        this.setState({
            show_save_loading_dialog : true,
            save_dialog_content : "답변을 제출하는 중입니다.<br/>잠시만 기다려주세요.",
        })
        await http.post("/rest/common/curation/submit", body, config)
        .then(res => {
            if (res.data.code == 200) {
                // axios 호출 후 응답 받은 result_uid 사용
                let result_uid = res.data["result_uid"];
                // window.location.href = (
                //     "/common/curation/result/"+result_uid
                //     +"?cookie_robotmd_user="+(this.state.cookie_robotmd_user != null ? this.state.cookie_robotmd_user : "") 
                //     +"&member_id="+(this.state.member_id != null ? this.state.member_id : "") 
                //     +"&guest_id="+(this.state.guest_id != null ? this.state.guest_id : "")
                //     +"&service_uid="+(StringUtil.getUrlParams("service_uid") != null ? StringUtil.getUrlParams("service_uid") : "")
                // )
                this.loadCurationResult(result_uid)
            } else {
                alert("결과 보기에 싪패하였습니다.")
                this.setState({
                    show_save_loading_dialog : false,
                })
            }
        })
        .catch(error => {
            console.log("큐레이션 질문 답변 제출 오류", error)
            this.setState({
                show_save_loading_dialog : false,
            })
        });
    }

    /*
    http://127.0.0.1:3000/common/curation/question_v2/29?member_id=&cookie_robotmd_user=RM2.4.9809388866.1758203227345&service_uid=b85a889c-bedf-11f0-9c41-0a9ea40d
    */
    async loadCurationResult(result_uid) {
        await http.get("/rest/common/curation/result/"+result_uid)
        .then(res => {
            let curation_result = res.data["result"];
            if (res.data.code == 200 && res.data["result"] != null) {
                this.setState({
                    curation_result: res.data["result"],
                    show_save_loading_dialog : false,
                }, () => {
                    this.showResult();
                });
                if (curation_result != null && curation_result["user_seq"] != null && curation_result["shop_no"] != null) {

                    let rp_script_parameter = "?user_seq="+curation_result["user_seq"]
                                        +"&shop_no="+curation_result["shop_no"]
                                        +"&rp_page_id="+curation_result["rp_iframe_page_id"]
                                        +"&result_uid="+result_uid
                                        +"&user_type="+this.state.user_type;
                    var s = document.createElement("script");
                    s.type = "text/javascript";
                    s.src = rp_script_url+rp_script_parameter
                    document.head.appendChild(s);
                }
            } else {
                alert("큐레이션 결과가 존재하지 않습니다.")
                window.location.href = "/common/curation/list/"+(StringUtil.getUrlParams("service_uid") != null ? StringUtil.getUrlParams("service_uid")  : this.props.match.params["service_uid"] != null ? this.props.match.params["service_uid"] : "")
                                        +"?cookie_robotmd_user="+(StringUtil.getUrlParams("cookie_robotmd_user") != null ? StringUtil.getUrlParams("cookie_robotmd_user")  : "")
                                        +"&member_id="+(StringUtil.getUrlParams("member_id") != null ? StringUtil.getUrlParams("member_id")  : "")
                                        +"&guest_id="+(StringUtil.getUrlParams("guest_id") != null ? StringUtil.getUrlParams("guest_id")  : "")
            }
        })
        .catch(error => {
            console.log("큐레이션 결과 조회 오류", error)
            alert("큐레이션 결과가 존재하지 않습니다.")
            window.location.href = "/common/curation/list/"+(StringUtil.getUrlParams("service_uid") != null ? StringUtil.getUrlParams("service_uid")  : this.props.match.params["service_uid"] != null ? this.props.match.params["service_uid"] : "")
                                    +"?cookie_robotmd_user="+(StringUtil.getUrlParams("cookie_robotmd_user") != null ? StringUtil.getUrlParams("cookie_robotmd_user")  : "")
                                    +"&member_id="+(StringUtil.getUrlParams("member_id") != null ? StringUtil.getUrlParams("member_id")  : "")
                                    +"&guest_id="+(StringUtil.getUrlParams("guest_id") != null ? StringUtil.getUrlParams("guest_id")  : "")
        });
    }

  // 설문 초기화 (state 기반 reset)
  resetSurvey = () => {
    this.setState({
      currentStep: 0,
      userAnswers: {},
      showResult: false,
      resultText: "무냐무냐 베스트 셀러",
    });
  };

  // 닫기 버튼 클릭
  handleClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    } else {
      // 콜백이 없으면 설문만 초기화
      this.resetSurvey();
    }
  };

  // 답변 버튼 클릭
  handleAnswer = () => {
    this.setState(
      (prevState) => {
        const isLastStep =
          prevState.currentStep >= this.state.curation.questions.length - 1;

        // 마지막 문항이면 currentStep 유지 & showResult true
        return {
          currentStep: isLastStep
            ? prevState.currentStep
            : prevState.currentStep + 1,
        };
      },
      () => {
        const { currentStep } = this.state;
        const isLastStep = currentStep >= this.state.curation.questions.length - 1;
        console.log("isLastStep", isLastStep);
        if (isLastStep) {
            this.onClickSubmit();
        }
      }
    );
  };

  // 결과 계산 & 결과 화면 전환
  showResult = () => {
    // const { userAnswers } = this.state;

    // // 기본 문구
    // let resultText = "무냐무냐 베스트 셀러";

    // // 두 번째 질문(스타일)에 대한 답변 (index 1)
    // const styleAnswer = userAnswers[1];

    // if (styleAnswer === "classic") {
    //   resultText = "품격있는 [클래식 라인]";
    // } else if (styleAnswer === "character") {
    //   resultText = "아이들이 꿈꾸는 [캐릭터 라인]";
    // } else if (styleAnswer === "basic") {
    //   resultText = "매일 입기 좋은 [에센셜 라인]";
    // }

    this.setState(
      {
        showResult: true,
        // resultText,
      },
      () => {
        // 완료 콜백 (필요하면 사용)
        // if (this.props.onComplete) {
        //   this.props.onComplete(this.state.userAnswers);
        // }
      }
    );
  };

  // 진행률 계산
  getProgressPercent = () => {
    const { currentStep, showResult } = this.state;

    if (showResult) {
      return 100;
    }

    return (
      ((currentStep + 1) / this.state.curation["questions"].length) *
      100
    );
  };

  // 질문 텍스트에 포함된 \n 처리
  renderMultilineText = (text) => {
    if (!text) return null;
    return text.split("\n").map((line, idx) => (
      <React.Fragment key={idx}>
        {line}
        {idx < text.split("\n").length - 1 && <br />}
      </React.Fragment>
    ));
  };

  onClickAnswer(question_seq, answer_seq) {
    console.log("onClickAnswer", question_seq, answer_seq);
    let answers = JSON.parse(JSON.stringify(this.state.answers));
    // filter
    let new_answers = answers.filter(answer => answer.question_seq != question_seq);
    new_answers.push(
        {
            question_seq : question_seq,
            answer_seq : answer_seq,
        }
    )
    this.setState({
        answers : new_answers
    }, () => console.log("answers",this.state.answers))

    console.log("onClickAnswer new_answers", new_answers);
  }

  renderQuestion = () => {
    const { currentStep } = this.state;
    // const data = SURVEY_DATA[currentStep];
    const data = this.state.curation["questions"][currentStep];

    if (!data) {
      return null;
    }
    return (
    <>
    <img src={this.state.file_domain + data["file_path"]} style={{width:"100%"}} onError={(e) => {e.target.style.display = "none"}}/>
      <div
        key={currentStep} // step이 바뀔 때마다 새로 마운트되어 fade-in 애니메이션 재생
        className="flex-1 flex flex-col p-6 fade-in"
      >

        {/* 질문 영역 */}
        <div className="mb-8 mt-4">
          <span className="text-indigo-600 font-bold text-sm tracking-wide mb-2 block">
            {`QUESTION 0${currentStep + 1}`}
          </span>
          <h2 className="text-2xl font-bold text-gray-800 leading-tight">
            {this.renderMultilineText(data.question_desc)}
          </h2>
          <p className="text-gray-500 mt-2 text-sm">
            원하시는 답변을 선택해주세요.
          </p>
        </div>

        {/* 옵션 버튼 영역 */}
        <div className="space-y-3 w-full">
          {data.answers.map((answers_obj) => (
            <button
              key={data.question_seq+"_"+answers_obj.answer_seq}
              type="button"
              className="option-btn flex items-center justify-between group"
            //   onClick={() => this.handleAnswer(answers_obj.question_seq)}
              onClick={() => {this.onClickAnswer(data.question_seq, answers_obj.answer_seq); this.handleAnswer(); }}
            >
              <span>{answers_obj.answer_desc}</span>
              <span className="w-5 h-5 rounded-full border-2 border-gray-300 flex items-center justify-center group-hover:border-indigo-500 transition">
                <div className="w-2.5 h-2.5 bg-indigo-500 rounded-full opacity-0 group-active:opacity-100 transition" />
              </span>
            </button>
          ))}
        </div>
      </div>
    </>
    );
  };

  renderResult = () => {
    const { resultText } = this.state;
    if (!this.state.curation_result) {
      return null;
    }

    return (
      <div className="flex-1 flex flex-col items-center justify-center p-8 text-center fade-in">
        <div className="w-20 h-20 bg-indigo-100 rounded-full flex items-center justify-center mb-6">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-10 w-10 text-indigo-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M5 13l4 4L19 7"
            />
          </svg>

        </div>
        <h2 className="text-2xl font-bold text-gray-800 mb-2">
          {this.renderMultilineText(this.state.curation_result["result_title"])}
        </h2>
        <p className="text-gray-600 mb-8">
          {this.renderMultilineText(this.state.curation_result["result_desc"])}
        </p>

        {/* <div className="w-full bg-gray-50 rounded-xl p-4 mb-6 text-left">
          <p className="text-xs text-gray-400 font-bold mb-1">
            추천 라인업
          </p>
          <p className="text-lg font-bold text-indigo-700">
            {resultText}
          </p>
        </div> */}

        <button
          type="button"
          className="w-full bg-gray-900 text-white py-4 rounded-2xl font-bold hover:bg-gray-800 transition shadow-lg"
          onClick={() => {
            window.opener.postMessage({ crChildData : {
				location: "/",
			}}, '*');
            window.close();
          }}
        >
          쇼핑 계속하기
        </button>

        <img src={this.state.file_domain + this.state.curation_result["file_path"]} style={{width:"100vw", marginTop:"2rem"}} onError={(e) => {e.target.style.display = "none"}}/>
      </div>
    );
  };

  render() {
    const { showResult } = this.state;
    const progressPercent = this.getProgressPercent();

    if (!this.state.tailwindLoaded) {
      return null; 
      // 또는 <div style={{display:'none'}}></div>
    }

    return (
      <div className="flex items-center justify-center min-h-screen py-10 bg-gray-100" id="user_curation_v2">
        <div className="survey-container">
          {/* 헤더 */}
          <div id="header" className="px-6 py-4 flex items-center justify-between border-b border-gray-100">
            <img
              id="hederLogo"
              src={
                this.state.curation?.file_path
                ? this.state.file_domain + this.state.curation.file_path
                : undefined
              }
              onError={(e) => {e.target.style.display = "none"} }
            />
            <button
              id="btnCloseUserCurationQuestion"
              type="button"
              onClick={() => {window.close();}}
              className="text-gray-400 hover:text-gray-600"
              style={{ display: this.state.isMobile ? 'block' : 'none' }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            <span id="headerTitle" className="font-bold text-gray-700">
                {this.state.curation["curation_title"]}
            </span>
            <div className="w-6" />
          </div>

          {/* 진행바 */}
          <div className="w-full bg-gray-100 h-1.5">
              <div
              className="progress-bar bg-indigo-600 h-1.5"
              style={{ width: `${progressPercent}%` }}
              />
          </div>

          <div style={{ overflowY: "auto", flex: 1 }}>          
            {/* 질문 / 결과 */}
            {showResult ? this.renderResult() : this.renderQuestion()}
          </div>
        </div>

        {this.state.show_save_loading_dialog &&
            <SaveDialogV2
                loading_image={round_loading_bar_purple}
                content={this.state.save_dialog_content}
                button_list={[{
                    title : "확인",
                    display_yn : "N",
                    event_method : () => { this.setState({show_save_loading_dialog : false}) }
                }]}
            />
        }
      </div>
    );
  }
}

export default UserCurationQuestion_v2;
